import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authApi } from '../services/apiService';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [status, setStatus] = useState<'form' | 'loading' | 'success' | 'error'>('form');
  const [message, setMessage] = useState('');

  const token = searchParams.get('token');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!token) {
      setStatus('error');
      setMessage('Missing reset token.');
      return;
    }

    if (password !== confirmPassword) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }

    if (password.length < 8) {
      setStatus('error');
      setMessage('Password must be at least 8 characters.');
      return;
    }

    setStatus('loading');

    try {
      const data = await authApi.resetPassword(token, password);
      setStatus('success');
      setMessage(data.message);
    } catch (err: any) {
      setStatus('error');
      setMessage(err.message);
    }
  };

  if (!token) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <h1 style={titleStyle}>Reset Password</h1>
          <p style={{ ...textStyle, color: '#ff6b6b' }}>Invalid reset link. Missing token.</p>
          <Link to="/" style={linkStyle}>Go to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={titleStyle}>Reset Password</h1>

        {status === 'success' ? (
          <>
            <p style={textStyle}>{message}</p>
            <Link to="/" style={linkStyle}>Go to Home</Link>
          </>
        ) : (
          <>
            {status === 'error' && <p style={{ ...textStyle, color: '#ff6b6b' }}>{message}</p>}

            <form onSubmit={handleSubmit}>
              <div style={passwordWrapperStyle}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="New password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8}
                  style={passwordInputStyle}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={eyeButtonStyle}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <div style={passwordWrapperStyle}>
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  minLength={8}
                  style={passwordInputStyle}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={eyeButtonStyle}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <button type="submit" disabled={status === 'loading'} style={buttonStyle}>
                {status === 'loading' ? '...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

const containerStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  minHeight: '80vh',
};

const cardStyle: React.CSSProperties = {
  background: '#2e2020', borderRadius: '16px', padding: '3rem',
  textAlign: 'center', maxWidth: '400px', width: '90%',
};

const titleStyle: React.CSSProperties = { color: '#fff', marginBottom: '1.5rem' };
const textStyle: React.CSSProperties = { color: '#b08a8a', marginBottom: '1rem' };

const passwordWrapperStyle: React.CSSProperties = {
  position: 'relative', marginBottom: '0.75rem',
};

const passwordInputStyle: React.CSSProperties = {
  width: '100%', padding: '12px 44px 12px 16px', borderRadius: '25px', border: 'none',
  background: '#3d2a2a', color: '#fff', fontSize: '1rem',
  boxSizing: 'border-box',
};

const eyeButtonStyle: React.CSSProperties = {
  position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)',
  background: 'none', border: 'none', color: '#815353', cursor: 'pointer',
  fontSize: '0.95rem', padding: '4px', display: 'flex', alignItems: 'center',
};

const buttonStyle: React.CSSProperties = {
  width: '100%', padding: '12px', borderRadius: '25px', border: 'none',
  background: '#815353', color: '#fff', fontWeight: 'bold', fontSize: '1rem',
  cursor: 'pointer', marginTop: '0.5rem',
};

const linkStyle: React.CSSProperties = {
  color: '#b08a8a', textDecoration: 'underline', fontSize: '1.1rem',
};

export default ResetPassword;
